/* eslint no-unused-vars: 1 */

(function() {
    'use strict';
    angular.module('shopAuth').service('mnploginProvider', [ '$http', '$q', '$injector', function($http, $q, $injector) {

        var config = $injector.get('config');

        function login(username, password, system) {
            var response = $http({
                method: 'PUT',
                url: config.apiURLs.LOGIN,
                data: {
                    username: username,
                    password: password,
                    authType: system
                }
            });
            return response;

        }

        function convertMSISDN(msisdn) {
            if ('0' === msisdn.charAt(0)) {
                msisdn = msisdn.slice(1);
            }
            msisdn = msisdn.replace(/[^0-9]/g, '').toString();
            if ('' !== msisdn) {
                msisdn = 'GSM' + msisdn;
            }
            return msisdn;
        }

        /**
         * change selected MSISDN for ussa login for multi subscriber account TODO: use for contract chooser
         */
        function changeMSISDN(msisdn) {
            var response = $http({
                method: 'PUT',
                url: config.apiURLs.LOGIN,
                data: {
                    username: msisdn,
                    authType: 'USSA'
                }
            });
            return response;

        }

        /**
         * logout from backend Notice: allways logout from bShop AND mMyVF
         */
        function logoutAll() {
            return $q.all([ logoutBShop(), logoutMyVF()
            ]);
        }

        /**
         * logout bShop in backend
         */
        function logoutBShop() {
            return $http({
                method: 'PUT',
                data: {
                    'authType': 'logout'
                },
                timeout: 600000,
                url: config.apiURLs.LOGOUT,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
        }

        /**
         * logout myVF in backend
         */
        function logoutMyVF() {
            return $http({
                method: 'GET',
                url: config.apiURLs.MYVFLOGOUT
            });

        }

        return {
            login: login,
            convertMSISDN: convertMSISDN,
            changeMSISDN: changeMSISDN,
            logoutAll: logoutAll
        };
    }
    ]);
}());
